import { CaseStatusActionType } from 'redux/actions/caseStatus';
import {
  CASE_STATUS_ERROR,
  CASE_STATUS_START,
  CASE_STATUS_SUCCESS,
  GET_SERVICE_STATUS_FAIL,
  GET_SERVICE_STATUS_START,
  GET_SERVICE_STATUS_SUCCESS,
} from 'redux/actions/types';
import type { CaseStatusState } from 'ts/types/case-status.types';

const initialState: CaseStatusState = {
  caseReference: '',
  data: [],
  error: null,
  loading: false,
  services: {
    loading: false,
    data: [],
  },
};

function caseStatusReducer(
  state = initialState,
  action: CaseStatusActionType,
): CaseStatusState {
  switch (action.type) {
    case CASE_STATUS_START:
      return {
        ...state,
        loading: true,
        caseReference: action.payload.caseReference,
      };
    case CASE_STATUS_ERROR:
      return { ...state, loading: false, error: action.payload, data: [] };
    case CASE_STATUS_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case GET_SERVICE_STATUS_START:
      return {
        ...state,
        services: {
          ...state.services,
          loading: true,
        },
      };
    case GET_SERVICE_STATUS_FAIL:
      return { ...state, services: { ...state.services, loading: false } };
    case GET_SERVICE_STATUS_SUCCESS:
      return {
        ...state,
        services: { ...state.services, loading: false, data: action.payload },
      };
    default:
      return state;
  }
}

export default caseStatusReducer;
